import React from 'react';
import { IconProps } from '.';

const SvgArrowChevronDoubleRight = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M3.97 4.53 11.44 12l-7.47 7.47 1.06 1.06L13.56 12 5.03 3.47 3.97 4.53Z' />
      <path fill={color} d='M10.97 4.53 18.44 12l-7.47 7.47 1.06 1.06L20.56 12l-8.53-8.53-1.06 1.06Z' />
    </svg>
  );
};

export default SvgArrowChevronDoubleRight;
